import apiClient from './apiClient';

/** Uma ocupação da CBO 2002, como `/v1/cbo` devolve. */
export interface OcupacaoCbo {
  codigo: string;
  codigoFormatado: string;
  titulo: string;
  familia: string | null;
  /** O nome popular que casou com a busca, quando foi por ele que a ocupação apareceu. */
  sinonimo: string | null;
}

class CboService {
  async buscar(termo: string, limite = 20): Promise<OcupacaoCbo[]> {
    const resposta = (await apiClient.get('/cbo/busca', { params: { q: termo, limit: limite } })) as unknown as {
      ocupacoes?: OcupacaoCbo[];
    };
    return resposta.ocupacoes ?? [];
  }
}

export const cboService = new CboService();
export default cboService;
